/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PropertyToPoiDistance
 */
export interface PropertyToPoiDistance {
    /**
     * 
     * @type {number}
     * @memberof PropertyToPoiDistance
     */
    poiId: number;
    /**
     * 
     * @type {number}
     * @memberof PropertyToPoiDistance
     */
    propertyId: number;
    /**
     * 
     * @type {Date}
     * @memberof PropertyToPoiDistance
     */
    modificationDate: Date;
    /**
     * 
     * @type {string}
     * @memberof PropertyToPoiDistance
     */
    durationFootFormatted: string;
    /**
     * 
     * @type {string}
     * @memberof PropertyToPoiDistance
     */
    durationPublicTransportFormatted: string;
    /**
     * 
     * @type {string}
     * @memberof PropertyToPoiDistance
     */
    durationCarFormatted: string;
}

export function PropertyToPoiDistanceFromJSON(json: any): PropertyToPoiDistance {
    return PropertyToPoiDistanceFromJSONTyped(json, false);
}

export function PropertyToPoiDistanceFromJSONTyped(json: any, ignoreDiscriminator: boolean): PropertyToPoiDistance {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'poiId': json['poiId'],
        'propertyId': json['propertyId'],
        'modificationDate': (new Date(json['modificationDate'])),
        'durationFootFormatted': json['durationFootFormatted'],
        'durationPublicTransportFormatted': json['durationPublicTransportFormatted'],
        'durationCarFormatted': json['durationCarFormatted'],
    };
}

export function PropertyToPoiDistanceToJSON(value?: PropertyToPoiDistance | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'poiId': value.poiId,
        'propertyId': value.propertyId,
        'modificationDate': (value.modificationDate.toISOString()),
        'durationFootFormatted': value.durationFootFormatted,
        'durationPublicTransportFormatted': value.durationPublicTransportFormatted,
        'durationCarFormatted': value.durationCarFormatted,
    };
}


